/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonFile,
    JsonFileFromJSON,
    JsonFileFromJSONTyped,
    JsonFileToJSON,
} from './JsonFile';

/**
 * 
 * @export
 * @interface ApiResultOfJsonFile
 */
export interface ApiResultOfJsonFile {
    /**
     * 
     * @type {JsonFile}
     * @memberof ApiResultOfJsonFile
     */
    data?: JsonFile;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFile
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonFile
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFile
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFile
     */
    result?: ApiResultOfJsonFileResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonFileResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonFileFromJSON(json: any): ApiResultOfJsonFile {
    return ApiResultOfJsonFileFromJSONTyped(json, false);
}

export function ApiResultOfJsonFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonFileFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonFileToJSON(value?: ApiResultOfJsonFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonFileToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

